import { Injectable } from "@angular/core";
import { API_URL } from "common/constants/sm-constants";
import { DataService } from "../base-data-services/data.service";
import { SystemService } from "common/services/core-services/system.service";
import { SmApiService } from "common/services/core-services/sm-api.service";
import { BatchListModel } from "common/models/page-models/Batches/batches-data-model";

 
@Injectable()
export class MentorBatchListDataService extends DataService<BatchListModel> {
    constructor(protected ss: SystemService,protected http: SmApiService) {
        super(ss,API_URL.getBatchListForMentorMapping,http);
    }
 
 
//    override getAPI_URL(): API_URL {
//         return API_URL.getDocumentTypeList;
//       }
   
    createInstance(): BatchListModel {
        return new BatchListModel();
    }

    
 
}